import React, {Suspense, useEffect} from 'react';

import "./i18n";

import {BrowserRouter as Router, Routes, Route, useLocation} from 'react-router-dom';

import { getQueryParam } from './utils/queryParams';

import { AuthProvider } from './context/authContext';

import Header from './components/common/Header';
import Footer from './components/common/Footer';

import DynamicRouteHandler from "./components/DynamicRouterHandler";
import './index.css';
import Homepage from "./components/Homepage/Homepage";
import Logout from "./components/Logout";
import MobileNav from "./components/common/MobileNav";
import ForumIndex from "./components/Forum/ForumIndex";
import {WidgetProvider} from "./context/widgetContext";
import ForumView from "./components/Forum/ForumView";
import CategoryView from "./components/Category/CategoryView";
import ThreadView from "./components/Thread/ThreadView";
import MemberView from "./components/Member/MemberView";
import VideoIndex from "./components/Video/VideoIndex";
import {isMobile} from "./utils/utils";
import VideoIndexMobile from "./components/Video/VideoIndexMobile";
import VideoView from "./components/Video/VideoView";
import Tag from "./components/Tag/Tag";
import Search from "./components/Search/Search";
import ThreadVideoIndex from "./components/ThreadVideo/ThreadVideoIndex";
import ThreadVideoIndexMobile from "./components/ThreadVideo/ThreadVideoIndexMobile";

const QueryParamHandler = () => {
  const location = useLocation();

  useEffect(() => {
    const encryptedUserId = getQueryParam('encryptedUserId', location);
    if (encryptedUserId) {
      localStorage.setItem('encryptedUserId', encryptedUserId);
    }
  }, [location]);

  return null;
};

function App() {
  return (
      <Suspense fallback="loading">
        <AuthProvider><WidgetProvider>

          <Router>
            <QueryParamHandler />
            <Header />

            <Routes>
              <Route path="/" element={<Homepage />} />

              <Route path="forums" element={<ForumIndex />} />

              <Route path="forums/:forumTitleId" element={<ForumView />} />

              <Route path="gai-goi-ha-noi" element={<CategoryView />} />

              <Route path="gai-goi-sai-gon" element={<CategoryView />} />

              <Route path="gai-goi-thanh-pho-khac" element={<CategoryView />} />

              <Route path="categories/:categoryTitleId" element={<CategoryView />} />

              <Route path="threads/:threadTitleId" element={<ThreadView />} />

              <Route path="thread-videos/:threadTitleId" element={isMobile() ? <ThreadVideoIndexMobile /> : <ThreadVideoIndex />} />

              <Route path="members/:usernameId" element={<MemberView />} />

              <Route path="videos" element={isMobile() ? <VideoIndexMobile /> : <VideoIndex />} />

              <Route path="videos/friends" element={isMobile() ? <VideoIndexMobile initialTab={'friends'} /> : <VideoIndex initialTab={'friends'} />} />

              <Route path="videos/vip" element={isMobile() ? <VideoIndexMobile initialTab={'vip'} /> : <VideoIndex initialTab={'vip'} />} />

              <Route path="videos/:videoTitleId" element={isMobile() ? <VideoIndexMobile initialTab={'normal'} /> : <VideoView />} />

              <Route path="tags/:tagUrl" element={<Tag />} />

              <Route path="search" element={<Search />} />

              <Route path="logout" element={<Logout />} />

              <Route path="*" element={<DynamicRouteHandler />} />
            </Routes>

            <Footer />
            <MobileNav />
          </Router>

        </WidgetProvider></AuthProvider>
      </Suspense>
  );
}

export default App;
